<template>
  <div :class="{ 'filter-menu-pop': !isMenu }">
    <div class="filter-booking m-block">
      <div
        class="text--20"
        :style="isMenu ? '' : 'font-size: 30px; margin-bottom: 20px;'"
      >
        חיפוש לפי:
      </div>
      <div class="filter-booking-tabs flex flex--start">
        <div class="form_check form_radio desk-no-marge">
          <label class="form_check_tx">
            ת.ז
            <input
              type="radio"
              name="edit_all_blocks"
              v-model="searchType"
              value="by_passport"
            /><span class="checkmark"></span>
          </label>
        </div>
        <div class="form_check form_radio desk-no-marge">
          <label class="form_check_tx">
            טלפון נייד
            <input
              type="radio"
              name="edit_all_blocks"
              v-model="searchType"
              value="by_phone"
            /><span class="checkmark"></span>
          </label>
        </div>
        <div class="form_check form_radio desk-no-marge">
          <label class="form_check_tx">
            שם
            <input
              type="radio"
              name="edit_all_blocks"
              v-model="searchType"
              value="by_name"
            /><span class="checkmark"></span>
          </label>
        </div>
      </div>
    </div>

    <div class="head_search relative">
      <ValidationObserver ref="searchForm">
        <form @submit.prevent="searchById" autocomplete="off">
          <validation-provider name="name" rules="required" v-slot="{ errors }">
            <input
              class="head_search_input"
              type="text"
              :placeholder="'חיפוש ' + searchPlaceholder"
              v-model="id"
              v-on:keypress="numbersOnly"
              autocomplete="off"
            />
            <span class="error-message" v-if="errors.length > 0">{{
              errors[0]
            }}</span>
          </validation-provider>
          <input class="head_search_submit" type="submit" value="" />
        </form>
      </ValidationObserver>
    </div>

    <div class="center results_loader" v-if="showSearchLoader">
      <div class="text--20">אנא המתן לטעינת תוצאות...</div>
      <vue-loaders-ball-clip-rotate
        color="black"
        scale="1.2"
      ></vue-loaders-ball-clip-rotate>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getHash } from "../../utilities/hash.js";
import SearchDesktop from "@/components/Popups/SearchDesktop.vue";
import DocSelect from "@/components/Popups/SearchDocSelect";

export default {
  name: "SearchFilter",
  props: {
    isMenu: { type: Boolean, default: false },
    customClass: { type: String, default: "" }
  },
  data() {
    return {
      id: "",
      query_id: "",
      searchType: "by_passport",
      selected_doctor: "",
      showSearchLoader: false,
      showSearch: false,
      allResults: []
    };
  },
  computed: {
    ...mapGetters(["activeDoctor"]),
    searchPlaceholder() {
      switch (this.searchType) {
        case "by_passport":
          return "ת.ז";
        case "by_phone":
          return "טלפון נייד";
        case "by_name":
          return "שם";
        default:
          return "";
      }
    }
  },
  methods: {
    numbersOnly(ev) {
      if (this.searchType == "by_name" || this.searchType == "by_passport")
        return true;
      ev = ev ? ev : window.event;
      var charCode = ev.which ? ev.which : ev.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        ev.preventDefault();
      } else {
        return true;
      }
    },
    filterSearchResults(results) {
      const filtered = results.filter(
        res => res.doctor_id == this.selected_doctor
      );
      const sortedByTime = filtered.sort((a, b) => {
        let aa = a.time.substring(0, 4);
        let bb = b.time.substring(0, 4);
        return aa < bb ? -1 : aa > bb ? 1 : 0;
      });
      return sortedByTime.sort((a, b) => {
        let aa = a.date
          .split("/")
          .reverse()
          .join();
        let bb = b.date
          .split("/")
          .reverse()
          .join();
        return aa < bb ? -1 : aa > bb ? 1 : 0;
      });
    },
    async searchById() {
      const isValid = await this.$refs.searchForm.validate();
      if (!isValid) return;
      this.showSearchLoader = true;
      this.query_id = this.id;
      this.allResults = [];
      let docs = [];
      this.$API
        .searchAppointments(
          this.activeDoctor.id,
          this.query_id,
          this.searchType
        )
        .then(res => {
          this.showSearchLoader = false;
          this.showSearch = true;
          res.data.map(row => {
            if (row) {
              let temp = {
                appType: row.DT_RowId.includes("surgery") ? "ניתוח" : "תור",
                id: row.real_patient.passport,
                appointment_id: row.DT_RowId.includes("surgery")
                  ? row.time.surgery_id
                  : row.time.appointment_id,
                doctor_id: row.doctor.doctor_id,
                date: this.$moment(row.date.date, "YYYY/MM/DD").format(
                  "DD/MM/YYYY"
                ),
                phone: row.phone.phone,
                name:
                  row.real_patient.first_name +
                  " " +
                  row.real_patient.last_name,
                time: row.time.time,
                insurance: row.insurance.insurance_name,
                status: row.status.status,
                note: row.notes.note
              };
              // Doctors
              const findDoc = docs.find(
                d => d.doctor_id == row.doctor.doctor_id
              );
              if (!findDoc) docs.push(row.doctor);
              // All res
              this.allResults.push(temp);
            }
          });
          if (docs && docs.length > 1) {
            this.$emit("close");
            this.$modal.show(DocSelect, { id: this.query_id, docs: docs });
          } else {
            if (docs && docs.length) this.selected_doctor = docs[0].doctor_id;
            const res = this.filterSearchResults(this.allResults);
            if (this.isMenu) {
              this.$modal.show(SearchDesktop, {
                id: this.query_id,
                results: res,
                isMenu: this.isMenu
              });
            } else {
              this.$emit("search", { id: this.query_id, results: res });
            }
            window.location.hash = getHash({
              searchQuery: this.query_id,
              searchType: this.searchType
            });
          }
          this.id = "";
          this.showSearch = false;
        });
    }
  },
  watch: {
    id(val) {
      if (val === "") this.showSearch = false;
    },
    async searchType(val) {
      this.id = "";
      await this.$refs.searchForm.reset();
    }
  },
  mounted() {
    this.$root.$on("selected-doctor", event => {
      this.selected_doctor = event.doc;
    });

    if (!this.isMenu) return;

    if (this.hashData && this.hashData.searchQuery) {
      this.searchType = this.hashData.searchType;
      setTimeout(() => {
        this.id = decodeURIComponent(this.hashData.searchQuery);
      }, 20);
      setTimeout(() => {
        this.searchById();
      }, 50);
    }
  }
};
</script>

<style>
.filter-menu-pop {
  width: 40%;
  margin: auto;
}
</style>
